<template>
  <section class="footer-info">
    <BaseContainer>
      <div class="footer-info__wrapper">
        <a href="#" class="footer-info__prev">
          <div class="footer-info__images">
            <figure>
              <img :src="getPrevImage" alt="Alt description for the image">
            </figure>
          </div>
          <div class="footer-info__title">
            <span class="footer-info__text">Read previous article</span>
            Barbecue: The secrets of the Greek way
            <BaseIcon class="footer-info__arrow" name="arrow_back"></BaseIcon>
          </div>
        </a>
        <a href="#" class="footer-info__next">
          <div class="footer-info__images">
            <figure>
              <img :src="getNextImage">
            </figure>
          </div>
          <div class="footer-info__title">
            <span class="footer-info__text">Read next article</span>
            Barbecue: The secrets of the Greek way
            <BaseIcon class="footer-info__arrow" name="arrow_forward"></BaseIcon>
          </div>
        </a>
      </div>
    </BaseContainer>
  </section>
</template>

<script>
import BaseContainer from '../elements/BaseContainer.vue'
import BaseIcon from '../elements/BaseIcon.vue'
export default {
  name: 'FooterInfo',
  components: { BaseIcon, BaseContainer },
  props: {
    image: {
      type: String,
      default: 'article-pic.jpg'
    }
  },
  computed: {
    getPrevImage() {
      return require('@/assets/images/' + this.image)
    },
    getNextImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.footer-info {
  @apply bg-body;
}
.footer-info__wrapper {
  @apply flex justify-center py-6 text-white;
}
.footer-info__prev,
.footer-info__next {
  @apply text-white no-underline;
}
.footer-info__prev {
  @apply flex-1 mr-4 flex align-top flex-row-reverse text-right;
}
.footer-info__next {
  @apply flex-1 ml-4 flex align-top text-left;
}

.footer-info__prev figure,
.footer-info__next figure {
  @apply hidden;
}
.footer-info__title {
  @apply flex flex-col justify-center font-semibold text-base;
}
.footer-info__text {
  @apply block font-semibold text-white text-xs tracking-wide opacity-50 mb-2;
}
.footer-info__arrow {
  @apply flex-1 flex flex-col justify-end mt-2;
}
@screen lg {
  .footer-info__prev {
    @apply mr-4;
  }
  .footer-info__next {
    @apply ml-4;
  }
  .footer-info__images {
    @apply min-w-1/3;
  }
  .footer-info__images {
    @apply min-w-1/3;
  }
  .footer-info__prev figure,
  .footer-info__next figure {
    @apply block aspect-ratio-16/9 bg-white relative overflow-hidden;
  }
  .footer-info__prev img,
  .footer-info__next img {
    @apply block absolute inset-y-0 inset-x-0 w-full;
  }
  .footer-info__prev .footer-info__title {
    @apply mr-4 font-normal text-lg;
  }
  .footer-info__next .footer-info__title {
    @apply ml-4 font-normal text-lg;
  }
  .footer-info__text {
    @apply text-sm tracking-wide;
  }
}
</style>